function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "50",
  height: "38",
  viewBox: "0 0 50 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M49.516.561c-.008-.008-.008-.024-.016-.033-.008-.008-.023-.016-.031-.024A1.632 1.632 0 0048.289 0H1.711C1.258 0 .844.19.539.504.523.52.508.52.499.537.493.545.485.56.477.57.18.892 0 1.33 0 1.816v34.376c0 .528.219 1.007.57 1.337l.008.009c.008.008.023.016.031.025.297.272.68.437 1.102.437h46.57c.422 0 .805-.173 1.11-.438.008-.008.015-.008.031-.016 0 0 0-.008.008-.008.343-.33.57-.801.57-1.338V1.816a1.95 1.95 0 00-.484-1.255zm-2.14 1.049L25.135 24.7a.19.19 0 01-.28 0L2.616 1.61h44.76zM1.515 35.416v-32.7l15.606 16.206L1.515 35.416zm1.21.982l15.482-16.362 5.593 5.804a1.67 1.67 0 001.195.512c.438 0 .867-.174 1.203-.512l5.593-5.804 15.482 16.362H2.726zm45.75-.982L32.87 18.922 48.477 2.716v32.7z",
  fill: "#010101"
})));